import { useStoryblokState as _useStoryblokState } from "@storyblok/react";
export { storyblokEditable } from "@storyblok/react";
export var useStoryblokState = function(param) {
    var story = param.story, options = param.options, _enableBridge = param.enableBridge, enableBridge = _enableBridge === void 0 ? false : _enableBridge;
    return _useStoryblokState(story, options, enableBridge);
};
